import { createContext, useContext } from 'react';
import { IAppData } from '../interfaces/IAppData';

export interface AppPropsContext {
  appData: IAppData;
  setAppData: (
    appData: Partial<IAppData>
    ) => void;
}

export const AppContext = createContext<AppPropsContext>({
  appData: {
    user: {
      userId: '',
      userEmail: '',
      userName: '',
      signedIn: false,
      currency: 'EUR',
      fcmToken: null,
    },
    scanning: [],
    analysisResult: null,
    newReport: false,
    newMessages: 0,
    loading: false,
    dataFetched: false,
    isOffline: false,
    data: {
      version: '',
      brands: [],
      corporations: [],
      reportMerchants: [],
      reportReceipts: [],
      reportProductItems: [],
      logs: []
    }
  },
  setAppData: () => { }
});

export const useAppContext = () => useContext(AppContext);